import React, { forwardRef } from "react";
import styled from "styled-components";

interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
  children: React.ReactNode;
}

const CardContainer = styled.div`
  border-radius: ${({ theme }) => theme.borderRadius.xl};
  padding: 1.5rem;
  box-shadow: ${({ theme }) => theme.shadows.md};
  margin-bottom: 1.5rem;
  border: 1px solid ${({ theme }) => theme.colors.border};
  transition: all 0.2s ease;
  background-color: white;

  &:hover {
    box-shadow: ${({ theme }) => theme.shadows.lg};
  }
`;

const CardTitle = styled.h2`
  font-size: 1.25rem;
  margin-top: 0;
  margin-bottom: 1rem;
  color: ${({ theme }) => theme.colors.text};
  font-weight: 600;
`;

export const Card = forwardRef<HTMLDivElement, CardProps>(
  ({ title, children, ...props }, ref) => {
    return (
      <CardContainer ref={ref} {...props}>
        {title && <CardTitle>{title}</CardTitle>}
        {children}
      </CardContainer>
    );
  }
);
